import { render } from "./SnackBar.vue?vue&type=template&id=620f34b4&scoped=true"
import script from "./SnackBar.vue?vue&type=script&lang=js"
export * from "./SnackBar.vue?vue&type=script&lang=js"

import "./SnackBar.vue?vue&type=style&index=0&id=620f34b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lrive\\source\\repos\\XOneFrameworkWEB\\XOneWebVue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620f34b4"]])

export default __exports__